export function formatInvestorsYield(v: number) {
  if (v) return Math.floor(v * 100 * 100) / 100;
  else return v;
}
